/* eslint-disable require-jsdoc */
import React, { useState, useEffect, useMemo } from 'react'
import { EXRLoader } from 'three-stdlib'
import { Environment } from '@react-three/drei'
import { BackSide } from 'three'

const envLoader = new EXRLoader()

const loadEXRTexture = (url) =>
  new Promise((resolve, reject) => {
    envLoader.load(url, resolve, undefined, reject)
  })

const constructEnvironmentMapURL = (map) =>
  `https://3dassets.royalbotania.com/envmaps/${map}.exr`

export function Env({ background, map, rotation, onDone, onError }) {
  const blur = 0
  const intensity = 0.5
  const [envMap, setEnvMap] = useState(null)

  // als de 'map' aangepast wordt, set URL
  const textureUrl = useMemo(() => constructEnvironmentMapURL(map), [map])

  useEffect(() => {
    let cancelled = false
    onDone?.(false)
    // loading
    loadEXRTexture(textureUrl)
      .then((texture) => {
        if (cancelled) return
        setEnvMap(null)
        setEnvMap(texture)
        onDone?.(true)
      })
      .catch((error) => {
        if (cancelled) return
        onError?.(error)
      })
    return () => {
      cancelled = true
      // free memory
      if (envMap?.dispose) envMap.dispose()
    }
  }, [textureUrl]) // (envMap niet in deps om reloading tegen te gaan)

  if (!envMap) return null

  return (
    <Environment background={background} blur={blur}>
      {background && <color attach="background" args={['black']} />}
      <mesh rotation={[0, rotation, 0]} scale={10}>
        <sphereGeometry />
        <meshBasicMaterial
          transparent
          opacity={intensity}
          map={envMap}
          side={BackSide}
          toneMapped={false}
        />
      </mesh>
    </Environment>
  )
}
